import { render, staticRenderFns } from "./BrowserBar.vue?vue&type=template&id=176bcbe6&scoped=true"
import script from "./BrowserBar.vue?vue&type=script&lang=js"
export * from "./BrowserBar.vue?vue&type=script&lang=js"
import style0 from "./BrowserBar.vue?vue&type=style&index=0&id=176bcbe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bcbe6",
  null
  
)

export default component.exports